<!-- 添加定时器 -->
<template>
    <div class='container containerBox'>
        <div class="handle-box">
            <cmp-time-desc :index="index" :parentData="dataTimeDesc" @next="handleSave"></cmp-time-desc>
        </div>
        <!-- 步骤设置 -->
        <div class="timing-step">
            <el-steps :active="active" align-center >
				<el-step title="设备信息" icon="iconfont icon-canshu"></el-step>
                <el-step title="时间设置" icon="iconfont icon-shijian"></el-step>
                <el-step title="控制对象" icon="iconfont icon-canshuduixiang"></el-step>
                <el-step title="控制参数" icon="iconfont icon-canshu"></el-step>
            </el-steps>
        </div>
        <!-- 内容 -->
        <div>
            <!-- 时间设置 -->
            <div v-show="active == 2" style="width:50%;margin:50px auto 0;">
                <cmp-setting-time :index="index" :parentData="dataSettingTime"  @next="handleSave"></cmp-setting-time>
            </div>
            <!-- 控制对象 -->
            <div v-show="active == 3" style="width:50%;margin:50px auto 0;">
                <cmp-control-meters :index="index" :parentData="dataTimeControlMeters" @next="handleSave"></cmp-control-meters>
            </div>
            <!-- 控制参数 -->
            <div v-show="active == 4" style="width:50%;margin:50px auto 0;">
                <template v-if="systemType">
                    <!-- 计费系统 -->
                    <cmp-control-form :index="index" :parentData="dataTimeControlForm" @next="handleSave"></cmp-control-form>
                </template>
                <template v-else>
                    <!-- 群控系统 -->
                    <cmp-control-form1 :index="index" :parentData="dataTimeControlForm" @next="handleSave"></cmp-control-form1>
                </template>
            </div>
            <!-- 按钮 -->
            <div style="width:50%;margin:50px auto 0;text-align:center;">
                <el-button v-if="active>1" @click="handleClick('prev')">上一步</el-button>
                <el-button @click="handleClick('next')" type="primary">{{active === '5' ? '保存' : '下一步'}}</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import CmpControlForm from './CmpAddTiming/CmpControlForm'
import CmpControlForm1 from './CmpAddTiming/CmpControlForm1'
import CmpControlMeters from './CmpAddTiming/CmpControlMeters'
import CmpSettingTime from './CmpAddTiming/CmpSettingTime'
import CmpTimeDesc from './CmpAddTiming/CmpTimeDesc'
import Timering from './Timering'
import Service from '@/api/Service'
// import Storage from '@/utils/storage'

export default {
    name:  'addtiming',
    data() {
        return {
            active: 1,   //  步骤
            index: 1,
			state:false,
			astate:false,
            dataTimeDesc: {},
            dataTimeControlForm: {},
            dataTimeControlMeters: {},
            dataSettingTime: {},
        };
    },

    components: {
        CmpControlForm,
        CmpControlMeters,
        CmpSettingTime,
        CmpTimeDesc,
        CmpControlForm1
    },

    computed: {
        ...mapGetters(['timingControl', "timeDesc", "projectsystemInfo"]),
        systemType() {
            return this.projectsystemInfo.sys_type_id !== 2;
        }
    },

    mounted() {
        let oid = this.$route.params.timingId
        if(oid>0) {
            this.getTimerInfo(oid);
        }
    },
    created() {
        // 获取分类
        this.$store.dispatch("getTimerKind").catch(res=>{
                
        })
        // 获取分组
        this.$store.dispatch("getMeterGroupList");
    },
    methods: {
        // 获取信息
        async getTimerInfo(oid) {
            
            let data = await Service.getTimerInfo({oid: oid});
            
            if(data) {
                
                let sysid = this.projectsystemInfo.sys_type_id
                let { timeControlForm, timeControlMeters, timeDesc, settingTime} = Timering(data, sysid);
                this.dataTimeDesc = timeDesc;
                this.dataTimeControlForm = timeControlForm
                this.dataTimeControlMeters = timeControlMeters
                this.dataSettingTime = settingTime
            }
            
        },
		// getstate(v){
		// 	this.state=v
		// },
		// getastate(v){
		// 	this.astate=v
		// 	this.handleSave(v)
		// },
        // 保存按钮
        handleClick(type) {
            switch (type) {
                case 'next':
                    this.index += 1;
                    break;
                case 'prev':
                    this.index -= 1;
                    this.active -= 1;
                    break;
                default:
                    break;
            }
        },
        // 参数保存结果
        handleSave(data) {
			// if(this.state && data){
			// }else{
			// 	this.active =1
			// 	this.index =1
			// 	return
			// }
            if(this.index == 4 && JSON.stringify(this.timeDesc) == "{}") {
                this.index -= 1;
                return
            }
            if(data) {
                this.active +=1;
            }else{
                this.index -= 1;
            }
        },
    }
}

</script>
<style>
    .timing-step .iconfont{
        font-size: 28px;
    }
</style>
